// extracted by mini-css-extract-plugin
export default {"inputEditUserDetails":"zsfa41JDcjq8yxNy69ST","textareaEditUserDetails":"ABYpWiuUoNtKOHZ7HHVG"};